import {StepData} from "../core/modules/openapi";

export class ApplicationFormOverview {
    id: string;
    steps: string[];

    constructor(init?: Partial<ApplicationFormOverview>) {
        Object.assign(this, init);
    }
}

export class CompletedApplicationForm {
    id: string;
    steps: Map<number, StepData> = new Map();

    constructor(init?: Partial<CompletedApplicationForm>) {
        Object.assign(this, init);
    }
}

export enum ApplicationFormStatus {
    New, InProgress, Complete
}
